import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BundleViewportDataState {
  viewportPageIndexInStore: number;
  /**
   * Temporary save current page id for restore viewportPageIndexInStore
   * after invalidate BUNDLE_SECTIONS_TAG (reorderBundle, sortBundle, addBundle, etc).
   */
  viewportPageIdForRestorePageIndexInStore: string | null;
}

const initialState: BundleViewportDataState = {
  viewportPageIndexInStore: 0,
  viewportPageIdForRestorePageIndexInStore: null
};

const bundleViewportDataSlice = createSlice({
  name: 'bundleViewportData',
  initialState,
  reducers: {
    setViewportPageIndexInStore: (state, action: PayloadAction<number>) => {
      state.viewportPageIndexInStore = action.payload;
    },
    setViewportPageIdForRestorePageIndexInStore: (state, action: PayloadAction<string | null>) => {
      state.viewportPageIdForRestorePageIndexInStore = action.payload;
    }
  },
  selectors: {
    selectViewportPageIndexInStore: (state) => state.viewportPageIndexInStore,
    selectViewportPageIdForRestorePageIndexInStore: (state) => state.viewportPageIdForRestorePageIndexInStore
  }
});

export const { setViewportPageIndexInStore, setViewportPageIdForRestorePageIndexInStore } =
  bundleViewportDataSlice.actions;

export const { selectViewportPageIndexInStore, selectViewportPageIdForRestorePageIndexInStore } =
  bundleViewportDataSlice.selectors;

export const bundleViewportDataReducer = bundleViewportDataSlice.reducer;
